import user from "@/api/user";
import {KEY_TOKEN, KEY_USERINFO} from "@/config";
import {Toast} from "vant";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    userInfo: (() => {
      const userInfoJson = localStorage.getItem(KEY_USERINFO);
      return userInfoJson && JSON.parse(userInfoJson) || {picture: ""};
    })(),
    token: localStorage.getItem(KEY_TOKEN) || null,
    tempLoginInfo: {
      checkPrivacy: false,
      phone: '',
      email: ''
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem(KEY_TOKEN, token);
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem(KEY_USERINFO, JSON.stringify(userInfo));
    },
    setTempLoginInfo(state, payload) {
      if (payload) {
        state.tempLoginInfo = {...state.tempLoginInfo, ...payload};
      } else {
        state.tempLoginInfo = {
          checkPrivacy: false,
          phone: '',
          email: ''
        }
      }
    }
  },
  getters: {
    loggedIn(state) {
      return !!state.token;
    },
    userAvatar(state) {
      if (!state.token) {
        return '';
      }
      return (state.userInfo && state.userInfo.picture) ;
    }
  },
  actions: {
    async login({state, commit}, payload) {
      try {

        let resp = null
        if (process.env.VUE_APP_CUSTOMER === 'jzz') {
          resp =  await user.loginWithPhone(payload)
        }else {
          resp =  await user.login(payload)
        }
        const userInfo = resp.data;
        const token = userInfo.token;
        delete userInfo.token;
        commit("setToken", token);
        commit("setUserInfo", userInfo);
        return userInfo;
      }catch (e) {
        throw e
      }

    },
    async register({state, commit}, payload) {
      try {
        const resp = await user.register(payload)

        const userInfo = resp.data;
        const token = userInfo.token;
        delete userInfo.token;
        commit("setToken", token);
        commit("setUserInfo", userInfo);
        router.replace("/")
      } catch (e) {
        Toast(e.message)
      }
    },
    async updateUser({state, commit}, profile) {
      await user.updateUser(profile);
      const userInfo = {...state.userInfo};
      if (profile.picture) {
        userInfo.picture = profile.picture;
      }

      if (profile.smsNotify) {
        userInfo.smsNotify = profile.smsNotify;
      }

      if (profile.nickName) {
        userInfo.nickName = profile.nickName;
      }

      if (profile.email) {
        userInfo.email = profile.email;
      }
      if (profile.gender) {
        userInfo.gender = profile.gender;
      }
      if (profile.age) {
        userInfo.age = profile.age;
      }
      commit('setUserInfo', userInfo);
    },
    async logout({commit}) {
      commit('setToken', null);
      commit('setUserInfo', null);
      localStorage.clear();
      router.replace('/');
    },
    async doneOnBoarding({state, commit}) {
      await user.doneOnBoarding()
      commit("setUserInfo", {...state.userInfo, isGuide: true})
    },
  },
}
